import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-gray.svg'


const _hoisted_1 = {
  class: "fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center",
  style: {"z-index":"1000"}
}
const _hoisted_2 = {
  class: "flex flex-col px-5 py-3 gap-3 bg-white rounded-xl",
  style: {"min-width":"563px","border-radius":"14px"}
}
const _hoisted_3 = { class: "flex flex-row items-center justify-between font-semibold" }
const _hoisted_4 = { class: "flex flex-col gap-5" }
const _hoisted_5 = { class: "flex flex-row items-start justify-start p-3 rounded-2xl bg-gray-lp-2800 border border-gray-lp-1600 gap-x-2" }
const _hoisted_6 = { class: "flex flex-col gap-3 w-full" }
const _hoisted_7 = {
  class: "flex flex-row justify-between items-center text-black-lp-100 text-2xl font-bold",
  style: {"min-height":"40px"}
}
const _hoisted_8 = {
  class: "px-2 py-0.5 rounded-2xl flex flex-row items-center gap-x-1 bg-gray-lp-300 text-white text-xs font-normal",
  style: {"height":"max-content"}
}
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", {
  width: "5",
  height: "5",
  viewBox: "0 0 5 5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M0 2.5C0 1.11929 1.11929 0 2.5 0C3.88071 0 5 1.11929 5 2.5C5 3.88071 3.88071 5 2.5 5C1.11929 5 0 3.88071 0 2.5Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_10 = { class: "flex flex-row items-center justify-between gap-x-1" }
const _hoisted_11 = { class: "text-xs flex flex-col w-full gap-y-2" }
const _hoisted_12 = { class: "text-gray-lp-800" }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = { class: "text-xs flex flex-col w-full gap-y-2" }
const _hoisted_15 = { class: "text-gray-lp-800" }
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = { class: "flex flex-row px-2 py-1 bg-blue-lp-600 text-blue-lp-700 items-center gap-x-1 rounded-md" }
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = { class: "text-black-lp-300 text-center text-sm text-white-lp-100 py-3 rounded-xl w-full" }
const _hoisted_20 = { class: "flex flex-row gap-x-3 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.components.modalDelayConfirmation.title")) + " ", 1),
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createVNode("img", {
            src: _imports_0,
            class: "w-6 h-6 cursor-pointer",
            alt: _ctx.$t('cargoV2.components.common.closeAlt')
          }, null, 8, ["alt"])
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("img", {
            src: _ctx.airportIcon,
            style: {"min-width":"40px","min-height":"40px","flex-shrink":"0"}
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.selectedFirstFlight?.flightNo) + " ", 1),
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("cargoV2.components.modalDelayConfirmation.transit", { count: _ctx.flight.transitNumber })), 1)
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("cargoV2.components.modalDelayConfirmation.flightRoute")), 1),
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.selectedFirstFlight?.originAirportCode) + " - " + _toDisplayString(_ctx.selectedFirstFlight?.destinationAirportCode), 1)
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("cargoV2.components.modalDelayConfirmation.estimatedDeparture")), 1),
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.formatDepartureDate(_ctx.selectedFirstFlight?.departureDate)), 1)
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode(_component_Icons, {
                name: "info",
                style: {"width":"14px","height":"14px"}
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.flyIn")) + " ", 1),
              _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.flyInValue", { hours: _ctx.departureHours, minutes: _ctx.departureMinutes })), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("span", {
            innerHTML: _ctx.$t('cargoV2.components.modalDelayConfirmation.body')
          }, null, 8, ["innerHTML"])
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("button", {
            class: "py-3 w-full rounded-md text-sm font-semibold text-red-lp-2400 border border-red-lp-2400",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, _toDisplayString(_ctx.$t("cargoV2.components.modalDelayConfirmation.changeSchedule")), 1),
          _createVNode("button", {
            class: "text-white py-3 w-full rounded-md text-s, font-semibold bg-red-lp-2400",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSave(_ctx.flight)))
          }, _toDisplayString(_ctx.$t("cargoV2.components.modalDelayConfirmation.confirmBooking")), 1)
        ])
      ])
    ])
  ]))
}